import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { SectionHeadline } from '@/components/SectionHeadline';
import React from 'react';
import { ContactForm } from '../career/ContactForm';
export function Contact(t0) {
  const $ = _c(11);
  const {
    job,
    initialInterest
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["career"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== t) {
    t2 = t("detail.form.title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <SectionHeadline className="mb-4 lg:mb-6" variant="inverted" anchorKey="detail.form.title">{t2}</SectionHeadline>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== initialInterest || $[6] !== job) {
    t4 = <div className="mx-auto mt-12 max-w-192 lg:mt-16"><ContactForm job={job} variant="detail" initialInterest={initialInterest} /></div>;
    $[5] = initialInterest;
    $[6] = job;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="relative z-10 px-4">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}